"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hyperLink = _interopRequireDefault(require("promo-js/lib/hyper-link"));

const PromoLogo = ({
  url,
  link,
  className
}) => {
  const renderLogo = () => /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)('promo-logo', className)
  });

  return url ? /*#__PURE__*/_react.default.createElement(_hyperLink.default, {
    href: url,
    link: link
  }, renderLogo()) : renderLogo();
};

PromoLogo.propTypes = {
  url: _propTypes.default.string,
  link: _propTypes.default.func,
  className: _propTypes.default.string
};
PromoLogo.defaultProps = {
  url: null,
  link: null,
  className: ''
};
var _default = PromoLogo;
exports.default = _default;